import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ReporteService } from '../../../services/reportes/reporte.service';
import { WeeklyReport } from '../../../models/report-client';
import { ExcelService } from '../../../services/excel/excel.service';
import { formatDate } from '@angular/common';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-report-weekly-page',
  templateUrl: './report-weekly-page.component.html',
  styleUrls: ['./report-weekly-page.component.scss']
})
export class ReportWeeklyPageComponent implements OnInit {

  report?: WeeklyReport;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private reportService: ReporteService,
    private excelService: ExcelService
  ) {}

  ngOnInit() {
    const reportId = this.route.snapshot.paramMap.get('id');
    if (reportId) {
      this.loadReport(reportId);
    }
  }

  private parseToDate(input: any): Date | null {
    if (!input && input !== 0) return null;

    if (typeof input === 'object' && input !== null && ('_seconds' in input || 'seconds' in input)) {
      const seconds = input._seconds ?? input.seconds;
      if (typeof seconds === 'number') return new Date(seconds * 1000);
    }

    if (typeof input === 'object' && typeof (input as any).toDate === 'function') {
      try {
        return (input as any).toDate();
      } catch {
        return null;
      }
    }

    if (typeof input === 'number') {
      if (input < 1e12) return new Date(input * 1000);
      return new Date(input);
    }

    if (typeof input === 'string' && input.trim().match(/^\d+$/)) {
      const n = parseInt(input, 10);
      if (n < 1e12) return new Date(n * 1000);
      return new Date(n);
    }

    if (typeof input === 'string') {
      const trimmed = input.trim();
      const ddmmy = trimmed.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/);
      if (ddmmy) {
        const day = parseInt(ddmmy[1], 10);
        const month = parseInt(ddmmy[2], 10) - 1;
        let year = parseInt(ddmmy[3], 10);
        if (year < 100) year += 2000;
        const hour = ddmmy[4] ? parseInt(ddmmy[4], 10) : 0;
        const minute = ddmmy[5] ? parseInt(ddmmy[5], 10) : 0;
        const second = ddmmy[6] ? parseInt(ddmmy[6], 10) : 0;
        return new Date(year, month, day, hour, minute, second);
      }

      const parsed = Date.parse(trimmed);
      if (!isNaN(parsed)) return new Date(parsed);
    }

    return null;
  }

  async loadReport(id: string) {
    this.reportService.getReportWeeklyById(id).subscribe({
      next: (res: any) => {
        console.log('Respuesta completa:', res);

        if (!res.data || !Array.isArray(res.data.data)) {
          console.error('Datos de reporte inválidos');
          this.loading = false;
          return;
        }

        this.report = {
          _id: res.data._id,
          date: res.data.date,
          totalClientes: res.data.totalClientes,
          data: res.data.data.map((c: any) => {
            const parsedRenov = this.parseToDate(c.fechaRenovacion);
            const fechaRenovacionStr = parsedRenov ? parsedRenov.toLocaleDateString() : 'N/A';

            const horasConsumidasNum = parseFloat(c.horasConsumidas ?? '0') || 0;
            let usoNum = 0;
            if (typeof c.uso === 'string') {
              usoNum = parseFloat(c.uso.replace('%', '').trim()) || 0;
            } else if (typeof c.uso === 'number') {
              usoNum = c.uso;
            }
            
            const parsedCorte = this.parseToDate(c.fechaCorte);
            
            return {
              cliente: c.cliente,
              plan: c.plan,
              fechaCorte: parsedCorte,
              horasConsumidas: horasConsumidasNum.toFixed(2),
              horasPlan: c.horasPlan,
              uso: usoNum.toFixed(1),
              fechaRenovacion: fechaRenovacionStr
            };
          })
        };

        this.loading = false;
      },
      error: (err) => {
        console.error('Error obteniendo reporte semanal:', err);
        this.loading = false;
      }
    });
  }

  async excel() {
    try {
      if (!this.report || !Array.isArray(this.report.data)) {
        return Swal.fire({
          icon: 'warning',
          title: 'No hay datos para exportar'
        });
      }

      const headers = [
        'Cliente',
        'Plan',
        'Horas consumidas',
        'Horas del plan',
        '% de uso',        
      ];

      const dataToPrint = this.report.data.map((item: any) => ({
        "0": item.cliente || 'N/A',
        "1": item.plan || 'Sin plan',
        "2": parseFloat(item.horasConsumidas || '0'),
        "3": item.horasPlan || 0,
        "4": (item.uso || 0) + '%',        
      }));

      const fileName = `Reporte Semanal ${formatDate(new Date(), 'dd MMMM yyyy', 'es-MX')}`;
      await this.excelService._createReport(
        dataToPrint,
        headers,
        fileName,
        'REPORTE SEMANAL DE CLIENTES',
        ['-'],
        [2, 3],
        [2, 3, 4]
      );

      Swal.fire({
        icon: 'success',
        title: 'Excel generado correctamente'
      });

    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Ocurrió un error al generar el Excel'
      });
    }
  }
}
